/**
 * A custom checkbox component with optional server synchronization.
 * Replaces MUI Checkbox component.
 *
 * @component
 * @param {Object} props - The component props
 * @param {string} props.label - The label text to display next to checkbox
 * @param {boolean} props.checked - The current checked state of checkbox
 * @param {Function} props.onChange - Callback function to update checkbox state
 * @param {string} [props.url] - Optional URL endpoint for server synchronization
 * @param {string} [props.field] - Optional field name for server data
 * @param {Object} [props.style={}] - Optional CSS styles to apply to container
 * @returns {JSX.Element} A checkbox with label in a flex container
 *
 * @author Forge
 * @date 2026-04-03
 * @version 1.0.0
 */
import React from "react";
import mut from "../hooks/mut";

export default function CustomCheckbox({ label, checked, onChange, url, field, style = {} }) {
  const handleChange = async (e) => {
    const newChecked = e.target.checked;
    onChange(newChecked);

    if (url && field) {
      await mut("post", url, { [field]: newChecked });
    }
  };

  return (
    <label className="custom-checkbox-container" style={style}>
      <input
        type="checkbox"
        className="custom-checkbox-input"
        checked={checked}
        onChange={handleChange}
      />
      <span className="custom-checkbox-box"></span>
      <span className="custom-checkbox-label">{label}</span>
    </label>
  );
}
